import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ButtonColorTestPage() {
  return <div className="w-full min-h-screen bg-white py-12 px-6" data-id="element-547">
      <div className="max-w-4xl mx-auto" data-id="element-548">
        {/* Back button */}
        <div className="mb-8" data-id="element-549">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-550">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-551" />
            <span data-id="element-552">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-553">
          <h1 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-554">
            CTA Button Color Options
          </h1>
          <div className="space-y-12" data-id="element-555">
            {/* Sunset Coral */}
            <div className="space-y-6" data-id="element-556">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-557">
                Sunset Coral (#f46b5b)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-558">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-559">
                  <span data-id="element-560">Primary Button</span>
                </button>
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-561">
                  <span data-id="element-562">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-563" />
                </button>
                <button className="border-2 border-[#f46b5b] text-[#f46b5b] px-6 py-3 rounded-md font-medium hover:bg-[#f46b5b] hover:text-white transition-colors" data-id="element-564">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Golden Amber */}
            <div className="space-y-6" data-id="element-565">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-566">
                Golden Amber (#f6b736)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-567">
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-568">
                  <span data-id="element-569">Primary Button</span>
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-570">
                  <span data-id="element-571">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-572" />
                </button>
                <button className="border-2 border-[#f6b736] text-[#f6b736] px-6 py-3 rounded-md font-medium hover:bg-[#f6b736] hover:text-white transition-colors" data-id="element-573">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Bright Sky Blue */}
            <div className="space-y-6" data-id="element-574">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-575">
                Bright Sky Blue (#4dc4f7)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-576">
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-577">
                  <span data-id="element-578">Primary Button</span>
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-579">
                  <span data-id="element-580">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-581" />
                </button>
                <button className="border-2 border-[#4dc4f7] text-[#4dc4f7] px-6 py-3 rounded-md font-medium hover:bg-[#4dc4f7] hover:text-white transition-colors" data-id="element-582">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Comparison Section */}
            <div className="pt-10 border-t border-gray-200" data-id="element-583">
              <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-584">
                Side-by-Side Comparison
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-585">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-586">
                  <span data-id="element-587">Sunset Coral</span>
                  <ArrowRightIcon size={18} data-id="element-588" />
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-589">
                  <span data-id="element-590">Golden Amber</span>
                  <ArrowRightIcon size={18} data-id="element-591" />
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-592">
                  <span data-id="element-593">Bright Sky Blue</span>
                  <ArrowRightIcon size={18} data-id="element-594" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}